import script from "./ChatInputArea.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatInputArea.vue?vue&type=script&setup=true&lang=js"

import "./ChatInputArea.vue?vue&type=style&index=0&id=72932a0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72932a0a"]])

export default __exports__